import React from "react";
import { Button } from "antd";
import { SaveOutlined, CheckOutlined } from "@ant-design/icons";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const FooterContainer = styled.div<{ isMobile: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: ${(props) => (props.isMobile ? "12px 16px" : "16px 40px")};
  display: flex;
  justify-content: ${(props) => (props.isMobile ? "center" : "flex-end")};
  align-items: center;
  gap: ${(props) => (props.isMobile ? "10px" : "16px")};
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1001;
  border-top: 1px solid #f0f0f0;
  height: ${(props) => (props.isMobile ? "70px" : "50px")};
`;

interface EvaluationFooterProps {
  onSave: () => void;
  loading: boolean;
  onDiscard?: () => void;
  isSaveDisabled?: boolean;
}

const EvaluationFooter: React.FC<EvaluationFooterProps> = ({
  onSave,
  loading,
  onDiscard,
  isSaveDisabled = false,
}) => {
  const { screen } = useWindowSize();
  const isMobile = ["sm", "md"].includes(screen);

  return (
    <FooterContainer isMobile={isMobile}>
      {isMobile ? (
        <>
          <Button
            type="primary"
            size="small"
            icon={<CheckOutlined />}
            loading={loading}
            onClick={onSave}
            style={{
              flex: 1,
              borderRadius: "8px",
              fontWeight: 700,
              fontSize: "14px",
              background: "#1890ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            Save Evaluation
          </Button>
        </>
      ) : (
        <>
          <Button
            size="middle"
            style={{ borderRadius: "8px", fontWeight: 600 }}
            onClick={onDiscard}
          >
            Discard
          </Button>

          <Button
            type={isSaveDisabled ? "default" : "primary"}
            size="middle"
            icon={<SaveOutlined />}
            style={{
              borderRadius: "8px",
              fontWeight: 600,
              background: "#1890ff",
            }}
            onClick={onSave}
            loading={loading}
            disabled={isSaveDisabled}
          >
            Save Evaluation
          </Button>
        </>
      )}
    </FooterContainer>
  );
};

export default EvaluationFooter;
